import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import isEmpty from 'is-empty';

import { signOut } from "../../user/actions";
import { fetchCreditLimit, fetchCreditLine } from '../../CreditLimit/actions';
import { fetchLoanOffers } from '../../loans/actions';
import { fetchUpcomingPayments } from '../../loans/actions';
import { paymentsSizeText, currencyTotal, daysBeforeDue, dueDateHumanized } from '../misc/UpcomingPaymentRecapper';
import { evaluateStatus, CustomerStatus } from '../misc/CustomerStatus';
import { PaymentStatus } from '../../shared/utils/PaymentStatus';

import Layout from "../../shared/components/layouts/MainLayout";

import OverdueCard from "../components/OverdueCard";
import OutstandingBalance from "../components/OutstandingBalance";
import UpcomingPayment from '../components/UpcomingPayment';
import UpcomingPaymentsSection from '../components/UpcomingPaymentsSection';
import UtilizationCard from "../../CreditLimit/components/UtilizationCard"
import NewlyOnboardedCard from '../components/NewlyOnboardedCard';
import RCLOfferNotificationSection from "../components/RCLOfferNotificationSection";
import BusinessAccountOpeningContainer from "../../business_account/components/BusinessAccountOpeningContainer";

import { PageName, PageViewName } from '../../shared/constants/SegmentEvents';
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';

class HomeContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      customerStatus: this.customerStatus,
    };
  }

  componentDidMount() {
    this.props.fetchCreditLimit();
    this.props.fetchUpcomingPayments();
    this.props.fetchLoanOffers();

    this.sendSegmentPageViewEvent();
    this.props.fetchCreditLine();
  }

  get unduePayments() {
    const filters = [PaymentStatus.UNDUE]
    const {upcomingPayments = []} = this.props
    return upcomingPayments
           .filter(payment => filters.includes(payment.status))
           .filter(payment => payment.payment.total > 0)
  }

  get overduePayments() {
    const filters = [PaymentStatus.OVERDUE]
    const {upcomingPayments = []} = this.props
    return upcomingPayments
           .filter(loanPlan => filters.includes(loanPlan.status))
           .filter(payment => payment.payment.total > 0)
  }

  get loading() {
    const { loadingCreditLimit, loadingCreditLine } = this.props;

    return loadingCreditLimit || loadingCreditLine;
  }

  upcomingPayments() {
    return this.unduePayments
  }

  sendSegmentPageViewEvent() {
    segmentEventTracker.setContext({page_name: PageName.HOME_SCREEN});
    segmentEventTracker.trackPageView(PageViewName.HOME_SCREEN_VIEWED);
  }

  get customerStatus() {
    const customer = this.props.user;
    return evaluateStatus(customer);
  }


  renderUpcomingPayment() {
    if(isEmpty(this.upcomingPayments())) return;

    const upcomingPayments = this.upcomingPayments();

    const { loadingUpcomingPayments } = this.props;

    return (
      <UpcomingPayment
        paymentsSizeText={paymentsSizeText(upcomingPayments)}
        total={currencyTotal(upcomingPayments)}
        daysBeforeDue={daysBeforeDue(upcomingPayments)}
        dueDateHumanized={dueDateHumanized(upcomingPayments)}
        loading={loadingUpcomingPayments}
      />
    );
  }

  renderUpcomingPayments() {
    const props = {
      callToAction: this.props.push,
      callToActionPath: '/loan_plans',
    };
    return <UpcomingPaymentsSection
      undueRepayments={this.unduePayments}
      loading={this.loading}
      {...props}
    />
  }

  isVerifiedOrOffered =  () => {
    const { customerStatus } = this.state;
    return(customerStatus === CustomerStatus.KYCVerified ||
      customerStatus === CustomerStatus.OfferedLoanOffer);
  }

  isNewlyOnboarded = () => {
    return this.state.customerStatus === CustomerStatus.Onboarded ||
      this.state.customerStatus === CustomerStatus.OnboardedAndTradeDocSubmitted;
  }

  renderNewlyOnboardedCard() {
    if(!this.isNewlyOnboarded()) return null;
    return(
      <Fragment>
        {
          !this.props.user.kyc_verified_at_least_once &&
          <div className="ds-card">
            <NewlyOnboardedCard
              isCallToAction={false}
            />
          </div>
        }
        <div className="ds-card">
          <NewlyOnboardedCard
            isCallToAction={true}
            redirectTo={this.props.push}
            redirectToUrl={'/apply-now'}
          />
        </div>
      </Fragment>
    );
  }

  renderOverdueCard = () => {
    let defaultProps = {
      overdueRepayments: this.overduePayments
    }

    defaultProps = {
      ...defaultProps,
      callToActionCopy: 'Contact Us',
      callToActionUrl: 'mailto:support@firstcircle.com',
      headingSubCopy: 'Contact us to settle your payment immediately to avoid more late fees.',
      footerCopy: '*This amount does not include additional fees yet. Contact us to know the exact amount you need to pay.',
      showId: false,
      showOverdueCount: false,
      showTableHeaders: false,
      showViewAllButton: true,
      sortById: false,
    }

    return (<OverdueCard {...defaultProps} />)
  }

  render() {
    const {
      creditLimit,
      creditLine,
    } = this.props;

    return (
      <Layout gridClassName="_marginTop--xxlarge-tabletUp --narrow _marginBottom--xxlarge-mobileOnly">
        <BusinessAccountOpeningContainer />
        {this.renderNewlyOnboardedCard()}
        {this.renderOverdueCard()}
        { this.isVerifiedOrOffered() &&
          <UtilizationCard
            creditLimit={creditLimit}
            creditLine={creditLine}
            loading={this.loading}
            screen="Home"
            redirectTo={this.props.push}
            leadId={(this.props.user.active_business_trustpass || {}).lead_id}
            fcLead={this.props.fc_lead}
          />
        }
        <div className="ds-card">
          { this.isVerifiedOrOffered() &&
            <OutstandingBalance
              loading={this.loading}
              creditLimit={creditLimit}
            />
          }
          {this.renderUpcomingPayment()}
          {this.renderUpcomingPayments()}
        </div>
        <RCLOfferNotificationSection loanOffers={this.props.loanOffers}/>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.shared.ui.loading.default,
    loadingCreditLimit: state.shared.ui.loading.creditLimit,
    loadingCreditLine: state.shared.ui.loading.creditLine,
    loadingUpcomingPayments: state.shared.ui.loading.upcomingPayments,
    loadingLoanOffers: state.shared.ui.loading.loanOffers,
    user: state.user,
    company: state.company,
    creditLimit: state.creditLimit,
    creditLine: state.creditLine,
    loanOffers: state.loanOffers.all.active,
    upcomingPayments: state.loans.upcomingPayments,
    notification: state.shared.ui.rcl_notification,
    maintenance_banner: state.shared.maintenance_banner,
    new_feature_banner: state.shared.new_feature_banner,
    fc_lead: state.fc_lead,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push: (url) => dispatch(push(url)),
    signOut: () => dispatch(signOut()),
    fetchCreditLimit: () => dispatch(fetchCreditLimit()),
    fetchCreditLine: () => dispatch(fetchCreditLine()),
    fetchLoanOffers: (userId) => dispatch(fetchLoanOffers()),
    fetchUpcomingPayments: () => dispatch(fetchUpcomingPayments())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);



// WEBPACK FOOTER //
// ./src/features/home/containers/Home.js